






















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Dialog extends Vue {
  @Prop({ type: String, required: false }) private dialogText!: string;
  @Prop({ type: Boolean, required: false }) private isErrorText!: boolean;
  @Prop({ type: Boolean, required: false }) private usingWaiter!: boolean;
  @Prop({ type: Boolean, required: false }) private dialogLock!: boolean;
  dialogShows = false;

  mounted(): void {
    Vue.set(this, "dialogShows", true);
  }

  hideDialog(): void {
    if (this.dialogLock === true) {
      return;
    }
    Vue.set(this, "dialogShows", false);
  }

  afterLeave(): void {
    this.$emit("hideDialog");
  }
}
